import { Box, InputAdornment, Stack, TextField } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { GetCountryOptions, GetStatusOptions } from "../../shared/ListOptions";
import { Track } from "../../../interfaces/dtos/track";
import { ActionBarSelectInput } from "../../shared/ActionBarSelectInput";
import { ChangeEvent } from "react";

export type FilterChangeParams = (
    filterType: "search" | "country" | "status",
    filterValue: string
) => void;

interface ConfigurationsListActionsLeftProps {
    tracks: Track[];
    search: string;
    filterCountry: string;
    filterStatus: string;
    onFilterChange: FilterChangeParams;
}

export const ConfigurationsListActionsLeft = ({
    tracks, search, filterCountry, filterStatus, onFilterChange
}: ConfigurationsListActionsLeftProps) => {

    const statusOptions = GetStatusOptions();
    const countryOptions = GetCountryOptions(tracks);

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        onFilterChange("search", e.target.value);
    }

    // allow parameter to be any
    // eslint-disable-next-line
    const handleCountryChange = (e: any) => {
        onFilterChange("country", e.target.value);
    }

    // allow parameter to be any
    // eslint-disable-next-line
    const handleStatusChange = (e: any) => {
        onFilterChange("status", e.target.value);
    }

    return (
        <Stack direction="row" sx={{ padding: 0, margin: '-5px 0 -10px -5px' }}>
            <Box>
                <TextField
                    id="configurations-search"
                    value={search}
                    variant="outlined"
                    size="small"
                    fullWidth
                    onChange={handleSearchChange}
                    slotProps={{
                        input: {
                            sx: { bgcolor: 'background.paper' },
                            startAdornment: <InputAdornment position="start"><SearchIcon color="primary" /></InputAdornment>,
                        }
                    }}
                />
            </Box>
            <Box sx={{ marginTop: '-16px', paddingLeft: '10px' }}>
                <ActionBarSelectInput
                    id="configurations-countryfilter"
                    value={filterCountry}
                    onChange={handleCountryChange}
                    hideFilterSearch={false}
                    options={[{ value: ' ', description: 'All countries' }, ...countryOptions]}
                    sx={{ minWidth: "200px" }}
                />
            </Box>
            <Box sx={{ marginTop: '-16px', paddingLeft: '10px' }}>
                <ActionBarSelectInput
                    id="configurations-statusfilter"
                    value={filterStatus}
                    onChange={handleStatusChange}
                    options={[{ value: ' ', description: 'All statuses' }, ...statusOptions]}
                    sx={{ width: "140px" }}
                />
            </Box>
        </Stack>
    )
}
